import * as React from "react";
import { forwardRef } from "react";
const SvgTextItalic = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 17, fill: "currentColor", viewBox: "0 0 16 17", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.887.251h3.364a.75.75 0 0 1 0 1.5h-2.942l-6.9 12.401h2.109a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1 0-1.5h2.942l6.899-12.4H8.484a.75.75 0 0 1 0-1.5h3.403Z" }));
const ForwardRef = forwardRef(SvgTextItalic);
export default ForwardRef;
